// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__6au14","option":"styles_option__1xRLd","active":"styles_active__WcX++"};